"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionType = void 0;
var QuestionType;
(function (QuestionType) {
    QuestionType[QuestionType["BOOLEAN"] = 0] = "BOOLEAN";
    QuestionType[QuestionType["OPEN"] = 1] = "OPEN";
    QuestionType[QuestionType["UPLOAD"] = 2] = "UPLOAD";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
//# sourceMappingURL=questionType.enum.js.map